import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import User from '../user/User';
import Timepoint from '../../../../../../foundation/time/Timepoint';

export default class AuthenticationToken extends Entity<AuthenticationToken> {

	public constructor (id: EntityId<AuthenticationToken>, private createdTimepoint: Timepoint, private userId: EntityId<User>, private value: string, private expiryTimepoint: Timepoint, private revokedTimepoint: Timepoint | null) {
		super(id);
	}

	public getCreatedTimepoint () {
		return this.createdTimepoint;
	}

	public getUserId () {
		return this.userId;
	}

	public getValue () {
		return this.value;
	}

	public getExpiryTimepoint () {
		return this.expiryTimepoint;
	}

	public getRevokedTimepoint () {
		return this.revokedTimepoint;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/aggregates/authenticationToken/AuthenticationToken.ts